var groupTokenRegex = /\[productname\]/mgi;
export var replaceGroupTokens = function (html, product) {
    groupTokenRegex.lastIndex = 0;
    return product ? html.replace(groupTokenRegex, product.productName) : html;
};
